export enum DocumentTypes {
  CmsMa = "CmsMa",
  CmsMaContinued = "CmsMaContinued",
  CmsMmp = "CmsMmp",
  CmsMmpContinued = "CmsMmpContinued",
  CciioJustificationSubmission = "CciioJustificationSubmission"
}

export const DocumentTypesLabels: Record<DocumentTypes, string> = {
  [DocumentTypes.CmsMa]: "CMS MA",
  [DocumentTypes.CmsMaContinued]: "CMS MA CONTINUED",
  [DocumentTypes.CmsMmp]: "CMS MMP",
  [DocumentTypes.CmsMmpContinued]: "CMS MMP CONTINUED",
  [DocumentTypes.CciioJustificationSubmission]: "Data for CCIIO Justification Submission"
};